"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Observers_1 = require("./utils/Observers");

var db_1 = require("./db");

var cross_fetch_1 = __importDefault(require("cross-fetch"));

var AnvokError_1 = __importDefault(require("./AnvokError"));

var AuthObserverState;

(function (AuthObserverState) {
  AuthObserverState[AuthObserverState["UNKNOWN"] = 0] = "UNKNOWN";
  AuthObserverState[AuthObserverState["DISCONNECTED"] = 1] = "DISCONNECTED";
  AuthObserverState[AuthObserverState["CONNECTING"] = 2] = "CONNECTING";
  AuthObserverState[AuthObserverState["CONNECTED"] = 3] = "CONNECTED";
})(AuthObserverState = exports.AuthObserverState || (exports.AuthObserverState = {}));

var Auth =
/** @class */
function () {
  function Auth(stitch) {
    var _this = this;

    this.state = AuthObserverState.UNKNOWN;
    this.user = null;
    this.observers = new Observers_1.Observers();
    this.stitch = stitch;
    this.repos = new db_1.Repos(stitch, this);
    stitch.auth.addAuthListener({
      onUserLoggedIn: function onUserLoggedIn(_auth, user) {
        _this.setUser(user);
      },
      onUserLoggedOut: function onUserLoggedOut(_auth, _user) {
        _this.setUser(null);
      }
    });

    if (stitch.auth.user) {
      this.setUser(stitch.auth.user);
    } else {
      this.setUser(null);
    }
  }

  Auth.prototype.getUser = function () {
    return this.user;
  };

  Auth.prototype.onStateChanged = function (change) {
    change({
      state: this.state,
      user: this.user
    });
    return this.observers.add(change);
  };

  Auth.prototype.logOff = function () {
    this.stitch.auth.logout();
  };

  Auth.prototype.logInAnonymous = function () {
    var _this = this;

    return new Promise(function (res) {
      var creds = _this.stitch.createAnonymousCredential();

      _this.stitch.auth.loginWithCredential(creds);

      res();
    });
  };

  Auth.prototype.logIn = function (email, password) {
    var _this = this;

    return new Promise(function (res, rej) {
      var params = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      };
      var appId = _this.stitch.app.info.clientAppId;
      var loginUrl = "https://eu-west-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/" + appId + "/service/auth/incoming_webhook/login";
      cross_fetch_1.default(loginUrl, params).then(function (r) {
        return r.json();
      }).then(function (token) {
        if (!token) {
          rej();
          return;
        }

        var creds = _this.stitch.createCustomsCredential(token);

        _this.stitch.auth.loginWithCredential(creds).catch(console.error);
      }).catch(console.error);
    });
  };

  Auth.prototype.passwordLost = function (email) {
    var _this = this;

    return new Promise(function (res, rej) {
      var params = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email
        })
      };
      var appId = _this.stitch.app.info.clientAppId;
      var url = "https://eu-west-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/" + appId + "/service/auth/incoming_webhook/passwordLost";
      cross_fetch_1.default(url, params).then(function (r) {
        return r.json();
      }).then(function (data) {
        if (data.error) {
          rej(new AnvokError_1.default("Une erreur s'est produite, veuillez verifier votre adresse", "err"));
        } else {
          res();
        }
      }).catch(console.error);
    });
  };

  Auth.prototype.passwordReset = function (email, token, password) {
    var _this = this;

    return new Promise(function (res, rej) {
      var params = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email,
          token: token,
          password: password
        })
      };
      var appId = _this.stitch.app.info.clientAppId;
      var url = "https://eu-west-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/" + appId + "/service/auth/incoming_webhook/passwordReset";
      cross_fetch_1.default(url, params).then(function (r) {
        return r.json();
      }).then(function (data) {
        if (data.error) {
          rej(new AnvokError_1.default(data.error, "err"));
        } else {
          res();
        }
      }).catch(console.error);
    });
  };

  Auth.prototype.invite = function (email, name, level) {
    if (level === void 0) {
      level = "user";
    }

    return this.stitch.app.callFunction("userInvite", [email, name, level]);
  };

  Auth.prototype.register = function (_email, _password, _name, _company) {
    return Promise.reject("Not implemented");
  };

  Auth.prototype.resendVerification = function () {
    return Promise.reject("Not implemented");
  };

  Auth.prototype.trigger = function () {
    this.observers.trigger({
      state: this.state,
      user: this.user
    });
  };

  Auth.prototype.setUser = function (user) {
    var _this = this;

    if (user) {
      this.state = AuthObserverState.CONNECTING;
      this.user = null;
    } else {
      this.state = AuthObserverState.DISCONNECTED;
      this.user = null;
    }

    return new Promise(function (res, rej) {
      if (user == null) {
        _this.state = AuthObserverState.DISCONNECTED;
        _this.user = null;

        _this.trigger();

        res(null);
      } else {
        if (user.profile.data) {
          var profile = user.profile.data;
          var dbuser = void 0;

          _this.repos.getUsers().get(profile.id).then(function (dbuser) {
            if (dbuser) {
              _this.user = {
                email: dbuser.email,
                name: dbuser.name,
                id: dbuser._id.toHexString(),
                verified: false,
                org: dbuser.org,
                level: dbuser.level,
                orgname: "org.name"
              };
              _this.state = AuthObserverState.CONNECTED;

              _this.trigger();

              res(_this.user);
              return Promise.resolve();
            } else {
              _this.state = AuthObserverState.DISCONNECTED;
              _this.user = null;

              _this.trigger();

              return Promise.reject("User not found.");
            }
          }).catch(console.error);
        } else {
          rej();
          console.error("Auth data invalid");
        }
      }
    });
  };

  return Auth;
}();

exports.default = Auth;